import { type FC } from "react";
import { Navigate } from "react-router-dom";

import { PageContentSpinner } from "../../../layout/components";
import { useLensSubmissionFlow } from "../../hooks/useLensSubmissionFlow";

export const LensSubmissionFlowRedirector: FC = () => {
    const { loading, route, state, error } = useLensSubmissionFlow();

    if (error) {
        throw error;
    }

    if (loading || !route) {
        return <PageContentSpinner />;
    }

    return <Navigate to={route} state={state} />;
};
